"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var client_1 = require("@apollo/client");
var AcButton_1 = __importDefault(require("../button/AcButton"));
var AcPdf_1 = require("./AcPdf");
var rotateFaxDocumentPageMutation = client_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation rotateFaxDocumentPageMutation($input: rotateFaxDocumentPageMutationInput!) {\n    rotateFaxDocumentPage(input: $input) {\n      success\n    }\n  }\n"], ["\n  mutation rotateFaxDocumentPageMutation($input: rotateFaxDocumentPageMutationInput!) {\n    rotateFaxDocumentPage(input: $input) {\n      success\n    }\n  }\n"])));
exports.CURSOR_SVG = "url(\"data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='1.5rem' height='1.5rem' viewBox='-10 -10 550 550' style='enable-background:new 0 0 512 512;' fill='white' stroke='black' stroke-width='30' xml:space='preserve'%3E %3Cpath d='M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z'/%3E %3C/svg%3E\"), pointer";
exports.RotationButtons = function (_a) {
    var index = _a.index, initialRotationArray = _a.initialRotationArray, setRotationArray = _a.setRotationArray, _b = _a.type, type = _b === void 0 ? 'button' : _b, editing = _a.editing, faxId = _a.faxId, faxDocumentType = _a.faxDocumentType;
    var sendRotation = client_1.useMutation(rotateFaxDocumentPageMutation)[0];
    var editingRef = react_1.useRef(editing || false);
    var refInitialRotationArray = react_1.useRef([]);
    refInitialRotationArray.current = initialRotationArray;
    var canvasMethodsRef = react_1.useContext(AcPdf_1.CanvasContext);
    var saveRotationArray = function () {
        var changed = function (el, index) { return el !== refInitialRotationArray.current[index]; };
        if (canvasMethodsRef.current.getRotationArray().length > 0 && faxId && faxDocumentType) {
            if (canvasMethodsRef.current.getRotationArray().some(changed)) {
                sendRotation({
                    variables: {
                        input: {
                            faxId: faxId,
                            docType: faxDocumentType,
                            rotationArray: canvasMethodsRef.current.getRotationArray(),
                        },
                    },
                });
            }
        }
    };
    // Save rotation array if the user enables editing mode and there are changes on the rotation array.
    react_1.useEffect(function () {
        editingRef.current = editing || false;
        if (editing) {
            saveRotationArray();
        }
    }, [editing]);
    react_1.useEffect(function () { return function () {
        // this code will only be run when the component unmounts
        // a ref is used to store the value because this useEffect will not have access to normal useState state due to watching only an empty array []
        // Save only when editor is disabled.
        if (!editingRef.current) {
            saveRotationArray();
        }
    }; }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        type === 'button' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(AcButton_1.default, { variant: "link", className: "my-1 p-0", width: "45", height: "45", onClick: function () {
                    var temp = __spreadArrays(canvasMethodsRef.current.getRotationArray());
                    temp[index] = (temp[index] + 360 - 90) % 360;
                    setRotationArray(temp);
                } },
                react_1.default.createElement("i", { className: "fas fa-undo fs-18 text-secondary" })),
            react_1.default.createElement(AcButton_1.default, { variant: "link", className: "my-1 p-0", width: "45", height: "45", onClick: function () {
                    var temp = __spreadArrays(canvasMethodsRef.current.getRotationArray());
                    temp[index] = (temp[index] + 90) % 360;
                    setRotationArray(temp);
                } },
                react_1.default.createElement("i", { className: "fas fa-redo fs-18 text-secondary" })))),
        type === 'link' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "p-0 btn text-white px-1 ml-2", onClick: function () {
                    var temp = __spreadArrays(canvasMethodsRef.current.getRotationArray());
                    temp[index] = (temp[index] + 360 - 90) % 360;
                    setRotationArray(temp);
                } },
                react_1.default.createElement("i", { className: "fas fa-undo fs-16" })),
            react_1.default.createElement("span", { className: "p-0 btn text-white px-1 ml-2", onClick: function () {
                    var temp = __spreadArrays(canvasMethodsRef.current.getRotationArray());
                    temp[index] = (temp[index] + 90) % 360;
                    setRotationArray(temp);
                } },
                react_1.default.createElement("i", { className: "fas fa-redo fs-16" }))))));
};
exports.RotationButtons.displayName = 'RotationButtons';
var templateObject_1;
//# sourceMappingURL=RotationButtons.js.map